import React, { Component }    from 'react';
import { withRouter }          from 'react-router';
import { connect }             from 'react-redux';
import { Accordion, Card,
         Button }              from 'react-bootstrap';
import { ClipLoader }          from 'react-spinners';
import { FaCheckCircle }       from 'react-icons/fa';
import { FaExclamationCircle } from 'react-icons/fa';
import { MdError }             from 'react-icons/md';
import PubSub                  from 'pubsub-js';
import DropDown                from './DropDown';
import { PubSubConstants }     from '../environment';
import { executeFetchData }    from '../../../../actions/pubsub/execute';
import { processFetchData }    from '../../../../actions/pubsub/process';

var apiHost = PubSubConstants.WebApiHost;

class Execute extends Component {
  constructor(props) {
    super(props);
    this.state   = { 
      executions : {}
    };
    
    this.reload  = this.reload.bind(this);
    this.execute = this.execute.bind(this);
    this.node    = this.node.bind(this);
  }
  
  node(container, tag, input, inputs) {
    var node = container.querySelector(tag + '[name="' + input.Name + '"]');
    var obj  = {
      key: node.name,
      value: node.value
    };
    
    if (input.Required && !node.value) {
      node.parentNode.classList.add('has-error');
      node.nextSibling.style.display = 'inline';
      return false;
    }
    
    inputs.push(obj);
    node.parentNode.classList.remove('has-error');
    node.nextSibling.style.display = 'none';
    return true;
  }
  
  // validate and execute
  execute(process) {
    var container  = document.querySelector('div[process="' + process.Id + '"]');
    var inputs     = [];
    var error      = false;
    var valid      = false;
    var node, obj  = null;
    
    for (var i = 0; i < process.Inputs.length; i++) {
      var input = process.Inputs[i];
      if (input.Type === 'Number' || input.Type === 'Text' || input.Type === 'Password') {
        valid = this.node(container, 'input', input, inputs);
        if (!valid) {
          error = true;
        }
      }
      else if (input.Type === 'TextArea') {
        valid = this.node(container, 'textarea', input, inputs);
        if (!valid) {
          error = true;
        }
      }
      else if (input.Type === 'CheckBox') {
        node = container.querySelector('input[name="' + input.Name + '"]');
        obj  = {
          key: node.name,
          value: node.checked
        };
        
        inputs.push(obj);
      }
      else if (input.Type === 'DropDown') {
        node = container.querySelector('select[name="' + input.Name + '"]');
        obj  = {
          key: node.name,
          value: node.value
        };
        
        inputs.push(obj);
      }
      else {
        error = true // can't proceed, unsure what it is
      }
    }
    
    if (!error) {
      let execute = {...this.state.executions};
      var current = execute[process.Id];
      
      current.loading = true;
      current.running = true;
      current.error   = false;
      
      this.setState({ executions: execute }, function() {
        var body = {
          process: process.Id,
          inputs: inputs      
        };
        
        this.props.fetchDataExecute(apiHost, body);
      });
    }
  }

  reload() {
    this.props.fetchDataProcess(apiHost);
  }
  
  subscriber(msg, data){
    if (msg === "pubsub.process.list") {
      var execute = {};
      data.forEach(function(element) {
        execute[element.Id] = {
          loading: false,
          running: false,
          error:   false        
        };
      });
    
      this.setState({ executions: execute });
    }
    else if (msg === "pubsub.process.executed") {
      let execute = {...this.state.executions};
      var current = execute[data.process];
      current.loading = false;
      current.running = true;
      current.error   = !data.success;
      this.setState({ executions: execute });
    }
  }

  componentDidMount() {
    this.tokenA = PubSub.subscribe('pubsub.process.list',     this.subscriber.bind(this));
    this.tokenB = PubSub.subscribe('pubsub.process.executed', this.subscriber.bind(this));
    this.reload();
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.tokenA);
    PubSub.unsubscribe(this.tokenB);
  }

  render() {
    let content = null;
    var panels = [];
    for (var i = 0; i < this.props.process.length; i++) {
      var inputs = [];
      var p      = this.props.process[i];
      
      if (p.Inputs) {
        for (var j = 0; j < p.Inputs.length; j++) {
          var input = p.Inputs[j];
          var key   = i + " " + j;
          var width = input.Width ? input.Width : 'inherit';
          if (input.Type === 'Text') {
            inputs.push(
              <div className='form-group block' key={key} style={{clear: 'both'}}>
                <label className='control-label' style={{marginRight: '5px'}}>{input.Name}</label>
                <input className='form-control' style={{width: width}} type='text' name={input.Name} />
                <div className="error-message col-sm-3">
                  <small className="text-danger">
                    {input.ErrorMessage}
                  </small>      
                </div>
              </div>
            );
          }
          else if (input.Type === "Password") {
            inputs.push(
              <div className='form-group block' key={key} style={{clear: 'both'}}>
                <label className='control-label' style={{marginRight: '5px'}}>{input.Name}</label>
                <input className='form-control' style={{width: width}} type='password' name={input.Name} />
                <div className="error-message col-sm-3">
                  <small className="text-danger">
                    {input.ErrorMessage}
                  </small>      
                </div>
              </div>
            );
          }
          else if (input.Type === 'Number') {
            inputs.push(
              <div className='form-group block' key={key} style={{clear: 'both'}}>
                <label className='control-label' style={{marginRight: '5px'}}>{input.Name}</label>
                <input className='form-control' style={{width: width}} type='number' name={input.Name} />
                <div className="error-message col-sm-3">
                  <small className="text-danger">
                    {input.ErrorMessage}
                  </small>      
                </div>
              </div>
            );
          }
          else if (input.Type === 'TextArea') {
            var rows  = input.Rows ? input.Rows : 4;
            var cols  = input.Cols ? input.Cols : 50;
            inputs.push(
              <div className='form-group block' key={key} style={{clear: 'both'}}>
                <label className='control-label' style={{marginRight: '5px'}}>{input.Name}</label>
                <textarea className='form-control' rows={rows} cols={cols} name={input.Name} />
                <div className="error-message col-sm-3">
                  <small className="text-danger">
                    {input.ErrorMessage}
                  </small>      
                </div>
              </div>
            );
          }
          else if (input.Type === 'CheckBox') {
            inputs.push(
              <div className='form-group block' key={key} style={{clear: 'both'}}>
                <label className='control-label' style={{marginRight: '5px'}}>{input.Name}</label>
                <input type='checkbox' name={input.Name} />
              </div>
            );
          }
          else if (input.Type === 'DropDown') {    
            inputs.push(
              <DropDown input={input} key={key} style={{clear: 'both'}} />
            );
          }
        }
      }
        
      let running = null;
      if (this.state.executions[p.Id] && this.state.executions[p.Id].running) {
        if (this.state.executions[p.Id].error) {
          running = <FaExclamationCircle color="red" size={30} />;
        }
        else {
          running = <FaCheckCircle color="green" size={30} />;
        }
      }
        
      panels.push(
        <Accordion key={p.Id}>
          <Card>
            <Card.Header>
              <Accordion.Toggle as={Button} variant="link" eventKey={p.Id}>
                {p.Name}
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey={p.Id}>
              <Card.Body>
                <div>
                  <label style={{marginRight: '5px'}}>ID: </label>
                  <span>{p.Id}</span>
                </div>
                <div process={p.Id} style={{marginBottom: '10px'}}>
                  {inputs}
                </div>
                { this.state.executions[p.Id] && this.state.executions[p.Id].loading ?
                  <ClipLoader
                    color={'#072659'} 
                    loading={this.state.executions[p.Id].loading} 
                  />
                  :
                  <div style={{clear: 'both'}}>
                    <button style={{marginTop: '10px'}} className=" c-btn c-btn--sm" onClick={this.execute.bind(this, p)}>
                      <span className="c-btn__text">Execute</span>
                    </button>
                    {running}
                  </div>
                }
                </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      );
    }

    if (this.props.process.length === 0 && !this.props.processIsLoading) {
      content = 
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          <button title='No results'><MdError size={48} color='orange' /></button>
        </div>;
    }
    else {
      content = 
        <div>
          {panels}
        </div>;
    }

    return (
      <div>
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          { this.props.processIsLoading ?
            <ClipLoader
              color={'#072659'} 
              loading={this.props.processIsLoading} 
            />
            : <span />
          }
        </div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    execute: state.pubsub.execute.execute,
    executeHasErrored: state.pubsub.execute.executeHasErrored,
    executeIsLoading: state.pubsub.execute.executeIsLoading,
    process: state.pubsub.process.process,
    processHasErrored: state.pubsub.process.processHasErrored,
    processIsLoading: state.pubsub.process.processIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataExecute: (host, params) => dispatch(executeFetchData(host, params)),
    fetchDataProcess: (host, params) => dispatch(processFetchData(host, params))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Execute));
